import Vue from 'vue'
import VueResource from 'vue-resource'
import RESOURCES from '@/global/resources'

Vue.use(VueResource)

const http = Vue.http
// http.options.root = 'http://127.0.0.1:8000/api/v1/iph'
http.options.root = process.env.VUE_APP_BASE_URL + RESOURCES.API_URI
http.options.emulateJSON = true

// http.interceptors.push(interceptors)

const SetBearerToken = (token) => {
  http.headers.common['Authorization'] = `Bearer ${token}`
}

export { http, SetBearerToken }
